import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import BaseComponent from '../BaseComponent';

const NAME = 'SideNavigation';

class SideNavigation extends BaseComponent {
	constructor(element) {
		super(element);
		this.initSideNavigation();
	}

	static get NAME() {
		return NAME;
	}

	initSideNavigation() {
		const element = this._element;
		const toggleButtonElement = SelectorEngine.findOne('.lta-side-nav__menu-btn', element);

		EventHandler.on(toggleButtonElement, 'click', () => {
			element.classList.toggle('lta-side-nav__visible');
		});
	}
}

export default SideNavigation;
